import HttpService from './HttpService';

const DataSyncApi = HttpService('/api/datasync/');
const doPost = (action, data) => DataSyncApi.post(action, data);

export default {
  syncData(dataToSync, activeSiteId) {
    const postData = {
      voyageReports: dataToSync.voyageReportsToBeSynced,
      vesselActivities: dataToSync.vesselActivitiesToBeSynced,
      bulkTransactions: dataToSync.bulkTransactionsToBeSynced,
      passengers: dataToSync.passengersToBeSynced,
      tankStatuses: dataToSync.tanksWithCurrentStatusToBeSynced
        .map((x) => (
          { ...x.currentTankStatus, idc: x.idc }
        )),
      safetyObservations: dataToSync.safetyObservationsToBeSynced
    };
    return doPost('SyncData', postData);
  },
};
